import React from 'react';
import validate from 'validate.js';
import { FormattedMessage } from 'react-intl';
import {
  addressFormErrors,
  getCountryLabelAndZones
} from '../../../app-bookings-request/forms/validate/billingAddressErrors';
import { isEmpty } from 'lodash';
import postalCodes from 'postal-codes-js';

const validateReviewOfferForm = (values, props) => {
  const {
    alcohol_consumed,
    are_host_rules_accepted,
    guest_social_events_policy_accepted,
    cardholders_name,
    identity_verification,
    billing_country,
    billing_street,
    billing_city,
    billing_zip,
    billing_state
  } = values;
  const { socialEventPolicyAgreementRequired, isHostUpdate, globalCountries } = props;

  const countryLabelAndZones = getCountryLabelAndZones(globalCountries, billing_country);

  const { selectCountry, enterStreetAddress, enterCity, selectState, enterValidPostalCode } = addressFormErrors;
  const { labels = {}, zones = [] } = countryLabelAndZones;

  const selectedCountryHasZones = !isEmpty(zones);

  validate.validators.isValidZip = (value) => {
    const zipCheck = postalCodes.validate(billing_country, value);
    return true === zipCheck
      ? undefined
      : enterValidPostalCode[labels.postalCode || 'Postal code'];
  };

  return {
    alcohol_consumed: validate.single(alcohol_consumed, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox_review_offer.review_offer_form.select_value' defaultMessage='Please select a value'/>
      }
    }),
    cardholders_name: validate.single(cardholders_name, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox_review_offer.review_offer_form.cardholders_name' defaultMessage="Enter cardholder's name and last name."/>
      }
    }),
    identity_verification: validate.single(identity_verification, {
      presence: {
        message: 'Please verify your identity.'
      },
      inclusion: {
        within: ['verified'],
        message: 'Please verify your identity.'
      }
    }),
    // only validate are_host_rules_accepted for offers, as it's not required for host updates
    are_host_rules_accepted: !isHostUpdate ? validate.single(are_host_rules_accepted, {
      presence: {
        message: <FormattedMessage id='inbox_review_offer.review_offer_form.are_host_rules_accepted' defaultMessage='Please accept the rules.'/>
      },
      inclusion: {
        within: [true],
        message: <FormattedMessage id='inbox_review_offer.review_offer_form.are_host_rules_accepted' defaultMessage='Please accept the rules.'/>
      }
    }) : null,
    // only validate guest_social_events_policy_accepted if required
    guest_social_events_policy_accepted: (socialEventPolicyAgreementRequired && !isHostUpdate) ? validate.single(guest_social_events_policy_accepted, {
      presence: {
        message: <FormattedMessage id='inbox_review_offer.review_offer_form.guest_social_events_policy_accepted' defaultMessage='Please accept the Social Event Policy.'/>
      },
      inclusion: {
        within: [true],
        message: <FormattedMessage id='inbox_review_offer.review_offer_form.guest_social_events_policy_accepted' defaultMessage='Please accept the Social Event Policy.'/>
      }
    }) : null,
    billing_country: validate.single(billing_country, {
      presence: {
        allowEmpty: false,
        message: selectCountry
      }
    }),
    billing_street: validate.single(billing_street, {
      presence: {
        allowEmpty: false,
        message: enterStreetAddress
      }
    }),
    billing_city: validate.single(billing_city, {
      presence: {
        allowEmpty: false,
        message: enterCity[labels.city || 'City']
      }
    }),
    // only validate if the selected country has provinces
    billing_state: validate.single(billing_state, {
      presence: {
        allowEmpty: !selectedCountryHasZones,
        message: selectState[labels.zone || 'State']
      }
    }),
    billing_zip: validate.single(billing_zip, {
      isValidZip: true
    })
  };
};

export default validateReviewOfferForm;
